import { useContext } from 'react'
import { Context } from '../context/mainContext'

export const useMainContext = () => useContext(Context)
export default useMainContext